import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class OrderRequestActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/OrderRequest/OrderRequestBrowser")
	}

	render() {
		return (
			<Activity 
				name="OrderRequest"
				RenderedComponent={this.RenderedComponent}
				context="OrderRequest"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OrderRequestActivity)
